module.exports = __webpack_public_path__ + "static/sweety-159b4ca8211bc3fbbf26412ed9faa005.png";